import React, { useCallback } from 'react';
import { Card } from 'react-bootstrap';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { JudgmentsForExternalReferralsSearch } from '../../components/Judgments/JudgmentsForExternalRefferalsSearch';

export const ExternalReferralsJudgmentsView: React.FC = () => {
  const spd = useSpdCore();

  const getData = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
    ) =>
      spd.judgments.getByUserCompanyByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
      ),
    [spd.judgments],
  );

  return (
    <Card>
      <Card.Title className="p-3">Lista wystawionych orzeczeń</Card.Title>
      <JudgmentsForExternalReferralsSearch
        getData={getData}
        getCount={spd.judgments.getByUserCompanyCount}
        withHistory={true}
        withFilterInColumns={true}
      />
    </Card>
  );
};
